import React from 'react'

interface IAddNewFolderName {
    setView: (type: any) => void;
    newFolderName: any;
    setNewFolderName: (value: any) => void
}

const AddNewFolderName = ({ setView, newFolderName, setNewFolderName }: IAddNewFolderName) => {
    return (
        <div className="cl-step">
            <h3 className="cl-step__heading">Add Photos</h3>
            <div className="cl-breadcrumb">
                <button onClick={() => setView('galleries')}>Galleries</button>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6" />
                </svg>
                <span>New folder</span>
            </div>

            <div className="cl-step__fields">
                <div className="input-field-wrapper">
                    <div className="input-field-label-row">
                        <label className="input-field-label">Folder Name</label>
                    </div>
                    <div className="input-field-box">
                        <input
                            className="input-field-input"
                            type="text"
                            placeholder="Enter folder name"
                            value={newFolderName}
                            onChange={e => setNewFolderName(e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddNewFolderName